<template>
  <button id="KEY_C" name="C" class="btn softkey-btn" aria-label="C" data-vcode="COLOR_KEY_2">
    <img src="/images/icn-softkey-C.svg" alt="" role="img" aria-hidden="true" />
  </button>
</template>
<script>
export default {};
</script>
